"use client";

import { statsData } from "@/lib/about-data";
import { motion } from "motion/react";

export default function HeroSection() {
  return (
    <section className="relative pt-48 pb-32 px-6 overflow-hidden">
      {/* Background Elements */}
      <div className="absolute inset-0 bg-hero dark:bg-darkmode transition-colors duration-300 -z-20"></div>
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-primary/10 rounded-full blur-[120px] translate-x-1/2 -translate-y-1/2 -z-10 animate-pulse"></div>
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-blue-500/10 rounded-full blur-[100px] -translate-x-1/2 translate-y-1/2 -z-10"></div>

      <div className="max-w-[83.75rem] mx-auto text-center relative z-10">
        <motion.div
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          className="inline-flex items-center gap-2 mb-6 px-4 py-2 rounded-full border border-primary/20 bg-white/50 dark:bg-white/5 text-primary text-xs font-bold tracking-widest uppercase backdrop-blur-sm shadow-sm"
        >
          <span className="w-2 h-2 rounded-full bg-primary animate-pulse"></span>
          System Integrators & Automation Partners
        </motion.div>

        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-5xl md:text-7xl font-bold text-midnight_text dark:text-white mb-8 leading-[1.1] tracking-tight"
        >
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-midnight_text">
            Engineering{" "}
          </span>
          <br />
          <span className="relative whitespace-nowrap">
            Safety
            <svg
              className="absolute w-full h-3 -bottom-1 left-0 text-primary opacity-40"
              viewBox="0 0 100 10"
              preserveAspectRatio="none"
            >
              <path
                d="M0 5 Q 50 10 100 5"
                stroke="currentColor"
                strokeWidth="8"
                fill="none"
              />
            </svg>
          </span>{" "}
          &{" "}
          <span className="relative whitespace-nowrap">
            Reliability
            <svg
              className="absolute w-full h-3 -bottom-1 left-0 text-primary opacity-40"
              viewBox="0 0 100 10"
              preserveAspectRatio="none"
            >
              <path
                d="M0 5 Q 50 10 100 5"
                stroke="currentColor"
                strokeWidth="8"
                fill="none"
              />
            </svg>
          </span>{" "}
        </motion.h1>

        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2 }}
          className="text-lg md:text-2xl text-muted max-w-3xl mx-auto mb-16 leading-relaxed"
        >
          We specialize in Ex/IS certified Wireless Telephony, Radio
          Communication, and Industrial Automation for the world's most
          demanding environments.
        </motion.p>

        {/* Stats Floating Cards */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4 }}
          className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-5xl mx-auto"
        >
          {statsData.map((stat, i) => (
            <div
              key={i}
              className="p-6 bg-white dark:bg-white/5 rounded-2xl border border-border dark:border-white/10 shadow-lg dark:shadow-none hover:-translate-y-1 transition-transform duration-300"
            >
              <div className="text-3xl md:text-4xl font-bold text-primary mb-2">
                {stat.value}
              </div>
              <div className="text-xs md:text-sm text-muted dark:text-white/60 font-medium uppercase tracking-wider">
                {stat.label}
              </div>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
